export default __webpack_public_path__ + "static/media/Project-5-SingleProject-MainImg.af3cde54.png";